import { normalizePhoneE164 } from './compliance';

export function prepareTenantForCreate(tenantData) {
  return {
    ...tenantData,
    phoneE164: tenantData.phone ? normalizePhoneE164(tenantData.phone) : '',
    contactPreferences: {
      smsOptOut: false,
      ...(tenantData.contactPreferences || {}),
    },
  };
}

export function prepareTenantForUpdate(updates) {
  const nextUpdates = { ...updates };

  if (Object.prototype.hasOwnProperty.call(updates, 'phone')) {
    nextUpdates.phoneE164 = updates.phone ? normalizePhoneE164(updates.phone) : '';
  }

  if (Object.prototype.hasOwnProperty.call(updates, 'contactPreferences')) {
    nextUpdates.contactPreferences = {
      smsOptOut: false,
      ...(updates.contactPreferences || {}),
    };
  }

  return nextUpdates;
}
